module.exports = __webpack_public_path__ + "static/img/ad4.8a67ca1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ad4.png
// module id = hazY
// module chunks = 7